import React, { Component } from "react";
import profilePic from "../images/profilePic4.JPG";
import "../css/intro.css";

export default class Introduction extends Component {
  render() {
    return (
      <div>
        <div className="Introduction">
          <div className="introText">
            <p>
              Hello — I'm Ross. I've spent 8 years turning slow, manual business
              processes into automated systems, from automating workplace safety
              processes, like SDS and Incident Management workflows, to business
              admin workflows like invoicing and expense tracking. If a team is
              doing something by hand repetitively, I'm usually thinking about
              how to make it run itself. I work primarily with code and modern
              web technologies.
            </p>
            <p>
              Outside of work you'll find me with family and friends, playing
              sports, or somewhere outdoors.
            </p>
          </div>
          <img src={profilePic} className="profilePic" alt="profilePicRossF" />
        </div>
      </div>
    );
  }
}
